import React from 'react'
import PropTypes from 'prop-types'

import '../Message.css'
import './ImageMessage.css'
import { templateImgStyle } from './config'
import { zoomImage } from '../../../actions/static'
import QuickReplyList from '../Reply/QuickReplyList'
import { getMessageLogo } from '../../../helper/getMessageLogo'
import classes from './styles.module.scss'

const ImageMessage = ({
  url,
  message,
  showReply,
  showLogo,
  device,
  settings,
  parentURL,
  postMessage,
  isFullScreenWidget,
  isMobile,
}) => {

  return (
    <>
      <div
        className={`${
          message.isFromBot && showLogo
            ? 'received-container_logo'
            : 'received-container'
        }`}>
        {message.isFromBot && showLogo && (
          <div className="received-logo">
            <img
              width={32}
              height={32}
              src={getMessageLogo(message, settings)}
              alt=""
              className="bot-logo"
            />
          </div>
        )}
        <div
          className={classes.templateImg}
          style={templateImgStyle(device, url)}
          onClick={zoomImage.bind(null, url, isFullScreenWidget, parentURL)}
        />
      </div>
      {showReply && (
        <QuickReplyList
          isFullScreenWidget={isFullScreenWidget}
          message={message}
          color={settings.color}
          postMessage={postMessage}
          isMobile={isMobile}
        />
      )}
    </>
  )
}

ImageMessage.propTypes = {
  url: PropTypes.string.isRequired,
  isFullScreenWidget: PropTypes.bool,
  showLogo: PropTypes.bool.isRequired,
  showReply: PropTypes.bool.isRequired,
  message: PropTypes.object.isRequired,
  device: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  settings: PropTypes.shape({
    logo: PropTypes.string,
    color: PropTypes.string,
    title: PropTypes.string,
    bot_name: PropTypes.string,
    popup_text: PropTypes.string,
    popup_delay: PropTypes.number,
    greeting_text: PropTypes.string,
    chat_history_level: PropTypes.string,
    is_background_blurred: PropTypes.bool,
    enable_login_name_field: PropTypes.bool,
    enable_login_email_field: PropTypes.bool,
    is_composer_input_enabled: PropTypes.bool,
  }),
}

export default ImageMessage
